<template lang="pug">
  .consultants
    .consultants__layout
      h2.consultants__title {{ 'base.consultants' | translate }}
      .consultants__toolbar
        v-btn(
          medium
          @click="modals.showCreateConsultant = true")
          v-icon(
            position-left
            font-size="1"
            icon="plus").mr-1
          span {{ 'base.add_user' | translate }}

      v-dialog(
        max-width="900"
        v-model="modals.showCreateConsultant")
        create-consultant-modal(
          @close="modals.showCreateConsultant = false")
    .choose-role      
      .cols-x__3.cols-x__3--offset-md
        v-select(
          item-value="key"
          :label="$t('activities.role')"
          :options="roles"
          v-model="role")
    consultants-table(
      :role="role"
    )

</template>

<script>
import CreateConsultantModal from './modals/CreateConsultantModal'
import ConsultantsTable from './table/ConsultantsTable'

export default {
  name: 'Consultants',

  components: {
    ConsultantsTable,
    CreateConsultantModal
  },
  computed: {
    roles () {
      return [
        { id: 0, name: this.$t('activities.consultant'), key: 'consultant' },
        { id: 1, name: this.$t('activities.staff'), key: 'staff' }
      ]
    }
  },

  data: () => ({
    modals: {
      showCreateConsultant: false,
    },
    role: 'consultant',
  })
}
</script>

<style lang="scss" scoped>
.choose-role {
  background: #fff;
  padding: 15px;
}
.consultants {
  &__layout {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 2.5rem;
  }

  &__title {
    font-size: 2.5rem;
    font-weight: 700;
  }
}
</style>
